import { getAccessToken } from '@hgj/common-tools'
import { parseUrlParams } from './utils/url'
import useUserStore from '@/store/useUserStore'
import useBaseStore from '@/store/useBaseStore'
import router from '@/plugins/router'
import { setCommonHead } from './utils/publicHeader'
import { loadI18nLanguage } from '@/plugins/i18n'
import useTabs from '@/hooks/useTabs'
import { loadActivity, getProductCodeByUrl } from '@/utils/common'
import { IS_GLOBAL } from './const'
/**
 * 预加载处理
 */
export const preLoad = async () => {
  const base = useBaseStore()
  base.product = getProductCodeByUrl()
  base.getDropDownList()
  // 挂载公共头组件
  const PUBLIC_HEAD_URL = import.meta.env.VITE_APP_PUBLIC

  useScriptTag(PUBLIC_HEAD_URL)
  loadI18nLanguage()
  !IS_GLOBAL && loadActivity()

  const urlQueryParams = parseUrlParams()
  const user = useUserStore()
  try {
    // 从公共token中获取用户凭证
    const ssoSessionId = getAccessToken()
    /**
     * 优先从url上获取
     */
    const refreshToken = () => {
      if (urlQueryParams.token || urlQueryParams.from === 'wx-h5') {
        let token = urlQueryParams.token
        if (token) localStorage.setItem('wx-h5-token', token)

        if (!token) token = localStorage.getItem('wx-h5-token') || ''

        return token || ''
      } else {
        return ssoSessionId || ''
      }
    }
    // 设置登录凭证
    user.setSessionId(refreshToken())

    // 从项目接口获取登录用户信息
    await user.getUserInfo()
    // 切换企业 清空tab
    const enterpriseId = user.info?.user?.enterpriseId
    if (enterpriseId !== user.enterPriseKey) {
      const { clearTab } = useTabs()
      clearTab()
      user.enterPriseKey = user.info?.user?.enterpriseId || ''
    }
  } catch (e) {
    // 出错就删除id，后续不知道有没有问题
    user.setSessionId('')
    console.error('PreLoad -> [Session Token Error]', e)
  }
  try {
    // 清空已存储的查询参数
    // 首次启动的路由path
    let firstPath = location.pathname
    /**
     * 获取路由跳转逻辑
     * 未登录/登录产品未开通，仅可见介绍页
     * 开通了，不可见介绍页，跳转至产品内
     */
    if (firstPath.includes('whitelist')) {
      // 推送页 隐藏公共头
      setCommonHead('header,footer,shortcut')
    } else if (
      !user.isLogin ||
      !user.isProjectEnabled ||
      !user.isCompanyEnabled
    ) {
      const { clearTab } = useTabs()
      clearTab()
      // 没登录只能在介绍页
      // 登录了没开通只能在介绍页
      firstPath = '/landing-page'
    } else if (firstPath === '/landing-page') {
      // 开通了，如果在介绍页去草稿箱，其他直接进入产品
      firstPath = '/draft'
    }
    /**
     * 解析当前url对应路由（包括url参数）
     * @link https://router.vuejs.org/zh/api/#routelocationraw
     */
    const entryRouter = router.resolve(`${firstPath}${location.search}`)
    // 处理UI，删除公共底部栏
    if (entryRouter.name !== 'LandingPage') setCommonHead('footer')
    await router.replace(entryRouter)
    await router.isReady()
  } catch (e) {
    console.error('PreLoad -> [Router Init Error]', e)
  }
  return Promise.resolve(true)
}
